const intialState = {
    trouserRedux : [],
    carousel_id : 2
}

const trouserSelectReducer = (state = intialState, action) => {
    switch(action.type){
        case "ADD_TROUSER_ITEM":
            let idAlreadyExists2 = state.trouserRedux.findIndex(i => i.id === action.data.id) > -1;
            if(idAlreadyExists2){
                return{
                    ...state,
                    trouserRedux : state.trouserRedux.filter(item => item.id !== action.data.id)
                }
            }
            return {
                ...state,
                trouserRedux : [...state.trouserRedux, action.data]
            }
        default:
            return state;
    }
}





export const addTrouser = (item) => {
    return {
        type : "ADD_TROUSER_ITEM",
        data : item
    }
}

export default trouserSelectReducer